import React, { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from './ui/button';
import { Select } from './ui/select';
import { Badge } from './ui/badge';
import { useToast } from './ui/use-toast';
import api from '../lib/api';
import { CheckSquare, X } from 'lucide-react';

export default function BulkActionsBar({ selectedTaskIds, onClearSelection }) {
  const [bulkStatus, setBulkStatus] = useState('');
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const bulkUpdateMutation = useMutation({
    mutationFn: (data) => api.post('/tasks/bulk-update', data),
    onSuccess: (response) => {
      const { success_count, failed_count } = response.data;
      toast({
        title: 'Actualización masiva completada',
        description: `${success_count} tareas actualizadas. ${failed_count} fallidas.`,
      });
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
      onClearSelection();
      setBulkStatus('');
    },
    onError: () => {
      toast({
        title: 'Error',
        description: 'No se pudo actualizar las tareas',
        variant: 'destructive',
      });
    },
  });

  const handleBulkUpdate = () => {
    if (!bulkStatus || selectedTaskIds.length === 0) return;
    
    bulkUpdateMutation.mutate({
      task_ids: selectedTaskIds,
      update_data: {
        estado_id: parseInt(bulkStatus),
        comentario: `Actualización masiva de ${selectedTaskIds.length} tareas`
      }
    });
  };

  if (selectedTaskIds.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-border shadow-lg p-4 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Badge variant="default" className="text-base px-4 py-2">
            <CheckSquare className="w-4 h-4 mr-2" />
            {selectedTaskIds.length} tareas seleccionadas
          </Badge>
          
          <Select
            value={bulkStatus}
            onChange={(e) => setBulkStatus(e.target.value)}
            className="w-64"
            data-testid="bulk-status-select"
          >
            <option value="">Seleccionar acción...</option>
            <option value="17">Cambiar a: En Reparación</option>
            <option value="18">Cambiar a: Completada</option>
            <option value="19">Cambiar a: Bloqueada</option>
          </Select>
          
          <Button
            onClick={handleBulkUpdate}
            disabled={!bulkStatus || bulkUpdateMutation.isPending}
            data-testid="apply-bulk-action"
          >
            {bulkUpdateMutation.isPending ? 'Actualizando...' : 'Aplicar'}
          </Button>
        </div>
        
        <Button
          variant="ghost"
          onClick={onClearSelection}
          data-testid="clear-selection"
        >
          <X className="w-4 h-4 mr-2" />
          Cancelar
        </Button>
      </div>
    </div>
  );
}
